import { render, staticRenderFns } from "./former-employee.vue?vue&type=template&id=1ac52adb&scoped=true&"
import script from "./former-employee.vue?vue&type=script&lang=js&"
export * from "./former-employee.vue?vue&type=script&lang=js&"
import style0 from "./former-employee.vue?vue&type=style&index=0&id=1ac52adb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac52adb",
  null
  
)

export default component.exports